<template>
    <div>
        <b-modal
            id="trademarkSearchFormModal"
            centered
            size="xl"
            no-close-on-backdrop
            ref="trademarkSearchFormModal"
            :title=" $t('trademarkSearchResponsible.info')"
            :cancel-title=" $t('others.cancel_title')"
            :ok-title=" $t('others.ok_title')"
            cancel-variant="outline-secondary"
            @ok.prevent="addOrUpdate"
            hide-footer
        >
        <b-card no-body class="border mt-1">
            <b-card-header class="p-1">
              <b-card-title class="font-medium-2">
                <feather-icon icon="LockIcon" size="18" />
                <span class="align-middle ml-50">{{  $t('trademarkSearchResponsible.responsible')  }}</span>
              </b-card-title>
            </b-card-header>
            <!--eslint-disable-->
            <table class="table table-striped table-bordered">
              <tbody>
                <tr v-for="trademarkSearchResponsibleItem in trademarkSearchResponsibleList" :key="trademarkSearchResponsibleItem.id">
                  <td >
                      <b-form-checkbox @change="changeResponsible($event, trademarkSearchResponsibleItem.id, trademarkSearchResponsibleItem.mailContactTypeId)" />                                 
                  </td>
                  <td>{{  trademarkSearchResponsibleItem.name  }}</td>
                  <td>{{ trademarkSearchResponsibleItem.email  }}</td>
                  <td>
                    <b-form-select v-model="trademarkSearchResponsibleItem.mailContactTypeId" value-field="id" text-field="name" :options="mailContactTypeList" />
                  </td>
                  <td>{{ trademarkSearchResponsibleItem.responsibleField  }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-modal>
    </div>
</template>
<script>
export default{
  props: {
      getTrademarkSearchResponsibleList: {type: Function},
    },
  data(){
    return {
      id: 0,
      trademarkSearchResponsibleList:[],
      mailContactTypeList:[],
    }
  },
  methods:{
    changeResponsible(selected, clientResponsibleId, mailContactTypeId) {
      const controller = { name: 'TrademarkSearchResponsible' }
      if (selected == true) { 
        const data = { trademarkSearchId: this.trademarkSearchId, clientResponsibleId: clientResponsibleId, mailContactTypeId: mailContactTypeId  }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/save', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.getTrademarkSearchResponsibleList()
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      }
    },
    showInfo(trademarkSearchId, clientId) {
      this.$refs['trademarkSearchFormModal'].show()
          this.trademarkSearchId= trademarkSearchId
          const data = {clientId: clientId,trademarkSearchId:trademarkSearchId}
          const controller = {name: 'ClientResponsible', actionName:'GetClientResponsibleListForModules'}
          const payload = {data: data, controller: controller}
          this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
              if(response.data.resultStatus == true){    
                  this.trademarkSearchResponsibleList = response.data.clientResponsibleList
                  this.mailContactTypeList = response.data.mailContactTypeList
              } else {
                  this.$bvModal.hide('trademarkSearchFormModal')
                  this.$WarningAlert(response.data.resultMessage)
              }  
          }) 
      },
  }
}
</script>